import React, { useMemo } from 'react';

import { useRouteWorkspace } from '../../contexts/RouteWorkspaceContext';
import Message from '../messages/Message';

const PREVIEW_MESSAGE_ID = 'profile-tag-preview-message';
const PREVIEW_MESSAGE_SORT_ORDER = 'profile-tag-preview';
const PREVIEW_MESSAGE_TEXT = 'Hello team!';

const ProfileTagPreview = ({ tag, tagColor }) => {
  const { profile, workspaceId, mainChannelId } = useRouteWorkspace();

  const previewAuthor = useMemo(() => {
    if (!profile) return null;
    return { ...profile, tag, tag_color: tagColor };
  }, [profile, tag, tagColor]);

  const previewMessage = useMemo(() => {
    if (!profile || !workspaceId) return null;
    return {
      id: PREVIEW_MESSAGE_ID,
      sort_order: PREVIEW_MESSAGE_SORT_ORDER,
      timestamp: Math.floor(Date.now() / 1000),
      author_id: profile.id,
      author_type: 'profile',
      text: PREVIEW_MESSAGE_TEXT,
      channel_id: mainChannelId,
      workspace_id: workspaceId,
      attachments: [],
      reactions: {},
      link_previews: [],
    };
  }, [profile, workspaceId, mainChannelId]);

  if (!previewMessage || !previewAuthor) return null;

  return <Message message={previewMessage} author={previewAuthor} interactive={false} standalone />;
};

export default ProfileTagPreview;
